import Dexie from "dexie";
import db from "../Db";

var DeleteGens = Dexie.async(function* () {
  yield db.open();
  yield db.GENS.clear();
});

export default DeleteGens;
